import _ from "lodash";
import produce from "immer";
import axios from "axios";
import strings from "../../../res/strings";
import { setAppProcessing, setAppSuccess, setAppError } from "../../common";

export const RETRIEVE_ACCOUNT_INFORMATION =
  "account/RETRIEVE_ACCOUNT_INFORMATION";
export const UPDATE_ACCOUNT_INFORMATION = "account/UPDATE_ACCOUNT_INFORMATION";

const RETRIEVE_ACCOUNT_INFORMATION_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const UPDATE_ACCOUNT_INFORMATION_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const initialState = {
  accountInformation: null,
  accountEmail: null,

  updateAccountInformationProcessing: false,
  updateAccountInformationProcessingMessage: null,
  updateAccountInformationSuccess: false,
  updateAccountInformationSuccessMessage: null,
  updateAccountInformationError: false,
  updateAccountInformationErrorMessage: null,
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case RETRIEVE_ACCOUNT_INFORMATION: {
        draft.accountInformation = action.accountInformation;
        draft.accountEmail = action.accountEmail;
        break;
      }

      case UPDATE_ACCOUNT_INFORMATION: {
        draft.accountInformation = action.accountInformation;

        break;
      }

      default: {
        break;
      }
    }
  });

export const retrieveAccountInformation = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_account.retrieveAccountInformation",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_ACCOUNT_RETRIEVE_ACCOUNT_INFORMATION,
        values
      )
      .then((response) => {
        const accountInformation = _.get(response, "data.account_information");
        const accountEmail = _.get(response, "data.account_email");

        dispatch({
          type: RETRIEVE_ACCOUNT_INFORMATION,
          accountInformation,
          accountEmail,
        });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "lib_account.retrieveAccountInformation",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        const error = RETRIEVE_ACCOUNT_INFORMATION_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  notificationType: "alert",
                  context: "lib_account.retrieveAccountInformation",
                  ...error,
                },
            history
          )
        );
      });
  };
};

export const updateAccountInformation = (
  {
    values,
    content,
    closeActiveFormEdit,
    processingState,
    successState,
    errorState,
  },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_authentication.authenticateAccount",
          message: strings.lib_common_state_loading,
        }
      )
    );

    const data = new FormData();
    for (let key in values) {
      data.append(key, values[key]);
    }

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env
            .REACT_APP_API_LIB_ACCOUNT_CREATE_UPDATE_ACCOUNT_INFORMATION,
        data
      )
      .then((response) => {
        const accountInformation = _.get(response, "data.account_information");
        dispatch({ type: UPDATE_ACCOUNT_INFORMATION, accountInformation });

        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "lib_account.retrieveAccountInformation",
                },
            history
          )
        );

        if (closeActiveFormEdit) {
          closeActiveFormEdit();
        }
      })
      .catch((errorResponse) => {
        const error = UPDATE_ACCOUNT_INFORMATION_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  notificationType: "alert",
                  context: "lib_account.retrieveAccountInformation",
                  ...error,
                },
            history
          )
        );

        if (closeActiveFormEdit) {
          closeActiveFormEdit();
        }

        if (_.get(content, "current")) {
          _.get(content, "current").scrollToTop();
        }
      });
  };
};
